import React from "react";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ServiceCard = ({ service, index, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.5, delay: (index % 4) * 0.1 }}
    className={className}
  >
    <RouterLink
      to={`/services/${service.slug}`}
      className="group h-full flex flex-col bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300"
    >
      <div className="h-48 overflow-hidden">
        <img
          src={require(`../assets/images/${service.image}`)}
          alt={service.heading}
          loading="lazy"
          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-custom-blue transition-colors duration-300">
          {service.heading}
        </h3>
        <p className="text-gray-600">{service.shortDescription}</p>
        <span className="mt-auto pt-4 inline-flex items-center font-semibold text-custom-blue group-hover:text-custom-red transition-colors duration-300">
          Learn more
          <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" />
        </span>
      </div>
    </RouterLink>
  </motion.div>
);

export default ServiceCard;
